import gratitude from "./homeConfig";
import affirmation from "./homeConfig";
import plan from "./homeConfig";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function HomeIntro() {
  const { title1, word1, image1 } = gratitude.gratitude;
  const { title2, word2, image2 } = affirmation.affirmation;
  const { title3, word3, image3 } = plan.plan;
  const [title, setTitle] = useState(title1);
  const [word, setWord] = useState(word1);
  const [image, setImage] = useState(image1);

  const next = () => {
    if (title === "Gratitude") {
      setTitle(title2);
      setWord(word2);
      setImage(image2);
    }
    if (title === "Affirmation") {
      setTitle(title3);
      setWord(word3);
      setImage(image3);
    }
  };
  const back = () => {
    if (title === "Affirmation") {
      setTitle(title1);
      setWord(word1);
      setImage(image1);
    }
  };
  return (
    <div className="container d-flex flex-column align-items-center h-100 p-5 main1">
      <h1 style={{ fontSize: "2.2rem", color: "#3AB0FF" }} className="mb-4">
        <span>Hanch</span>
        <span style={{ color: "#F39237" }}>o</span>
        <span>r</span>
      </h1>
      <img src={image} alt="" />
      <h2 className="blue-color">{title}</h2>
      <h5 className="text-center my-3">{word}</h5>
      <div className="dots d-flex gap-3 my-3">
        <div className={title === title1 ? "dot active-dot" : "dot"}></div>
        <div className={title === title2 ? "dot active-dot" : "dot"}></div>
        <div className={title === title3 ? "dot active-dot" : "dot"}></div>
      </div>
      <div className="d-flex justify-content-between align-items-center w-100 mt-5">
        <h6 onClick={() => back()} className={title !== title2 ? "btn next" : "btn"}>Back</h6>
        <Link to='register'><button className={title !== title3 ? "btnG next" : "btnG"}>
          Get Started
        </button></Link>
        <h6 onClick={() => next()} className={title === title3 ? "btn next" : "btn"}>
          Next
        </h6>
      </div>
    </div>
  );
}
